import { styled } from '@mui/material/styles'
import ReactCrop from 'react-image-crop'

import { PreviewProps } from '#/components/FormCall/Inputs/InputImage/types'
import { Actions } from '#/components/FormCall/Inputs/InputImage/View/actions'
import { Image } from '#/components/Image'

import 'react-image-crop/dist/ReactCrop.css'

const MAX_HEIGHT = '55vh'

const Crop = styled(ReactCrop)({
  maxHeight: MAX_HEIGHT,
})

const StyledImage = styled(Image)({
  borderRadius: 0,
  filter: 'drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.6))',
  maxHeight: MAX_HEIGHT,
})

export const Preview = ({
  actions,
  aspectLocked,
  crop,
  cropping,
  disabled,
  failed,
  file,
  imageRef,
  onAction,
  onCropChange,
  onCropComplete,
  onImageLoad,
  preview,
}: PreviewProps) => {
  return (
    <>
      <StyledImage
        alt="Preview"
        failed={failed}
        file={preview}
        style={cropping ? { display: 'none' } : {}}
        actions={!cropping}
        slotProps={{
          root: { sx: { position: 'unset' } },
        }}
      />
      <Crop
        crop={crop}
        onChange={onCropChange}
        onComplete={onCropComplete}
        aspect={aspectLocked}
        style={!cropping ? { display: 'none' } : {}}
      >
        <StyledImage actions={false} ref={imageRef} alt="Crop" file={file} onLoad={onImageLoad} />
      </Crop>
      <Actions actions={actions} disabled={disabled} onAction={onAction} />
    </>
  )
}
